/**
 * Created by Languagenut on 10/09/2019.
 */


import React  from 'react';
import VocabularyBlock from './generating_vocabulary_block.js';
import {Row , Col} from 'react-bootstrap'
import LanguageSelect from '../language_select.js';
import Translation from '../../store/internationalization-store.js'
import {ProductService} from '../../services';
import ContentService from '../../services/content-service.js';
import Package from '../../classes/package.js';
import Vocabulary from './vocabulary.js';
function isDataURL(s) {
    return !!s.match(isDataURL.regex);
}

isDataURL.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

export default class EditVocabulary extends Vocabulary {

    constructor(props) {
        super();
        this.props = props;
        this.loaded = false;
    }

    componentDidMount(){
        ProductService.getAllLanguages();

        ContentService.getCustomVocabularyModuleSummary(this.props.catalogUID).then(function(response){

            if(!response) return;

            this.catalog = response.catalog;
            this.uid = this.catalog.uid;

            ContentService.getVocabTranslation(this.catalog.module_uid, this.catalog.learning_ietf, this.props.catalogUID).then(function(response){

                if(!response) return;
                if(!response.vocabTranslations) return;



                for(var i = 0 ; i < response.vocabTranslations.length; i++ )
                {
                    console.log(response.vocabTranslations[i]);

                    this.vocabularies.push({
                        uid:i,
                        learning:{text:response.vocabTranslations[i].word},
                        support:{text:response.vocabTranslations[i].originalWord},
                        learningAudio:{
                            available:true,
                            soundPath:response.vocabTranslations[i].learningAudio,
                        },
                        supportAudio:{
                            available:true,
                            soundPath:response.vocabTranslations[i].audio,
                        },
                        picture:{
                            available:true,
                            path:response.vocabTranslations[i].picture,
                        }
                    })


                }



                this.setState({
                    name:this.catalog.title,
                    description:this.catalog.description,
                    learning:this.catalog.learning_ietf,
                })
            }.bind(this))

        }.bind(this));
    }

    getVocabularies(){

        let arr = [];
        for(var idx = 0 ; idx < this.vocabularies.length; idx++)
        {
            if(this.vocabularies[idx] == null) {
                arr.push(null);
            } else {
                if (this.vocabularies[idx].valid == undefined) {
                    this.vocabularies[idx].valid = true;
                }
                arr.push(<VocabularyBlock incorrect={!this.vocabularies[idx].valid} edit={!this.loaded} blockInit={!this.loaded} 
                    supportAudio={this.vocabularies[idx].supportAudio} learningAudio={this.vocabularies[idx].learningAudio} 
                    picture={this.vocabularies[idx].picture} onUpdate={this.onUpdate.bind(this)} languageIETF={this.state.learning} 
                    supportIETF={this.state.support} support={this.vocabularies[idx].support} learning={this.vocabularies[idx].learning} 
                    onDeleted={this.onRemove.bind(this)} index={idx} />)
            }
        }
        
        if(this.vocabularies.length > 0)
        {
            this.loaded = true;
        }
        return arr
    }

    makeModule(){

        var vocabs = [];

        for(var i = 0 ; i < this.vocabularies.length; i++)
        {
            if(!this.vocabularies[i] || this.vocabularies[i] == null) continue;
            vocabs.push(this.vocabularies[i]);
        }

        this.setState({
            saving:true,
            made:0,
            tomake:vocabs.length
        });

        if(vocabs.length < this.limit)
        {
            this.setState({saving:true});
            return;
        }

        ContentService.editModule(this.state.name , this.state.learning , this.state.support , this.state.description , this.uid).then(function(response){
            this.makeVocaularies(0 , vocabs , response.uid);
        }.bind(this))
    }

    getLanguage(){

            if(!this.state.learning) return;
            return  <Row>
                        <Col md={6}><LanguageSelect disabled priority={this.state.learning} returnValue={(language)=>{ console.log(language); 
                            sessionStorage.setItem("packageUid", language.packageUid); 
                            this.setState({learning:language.ietf}) }} title={Translation.get(2211 , 'Learning Language')}/></Col>
                        <Col md={6}><LanguageSelect disabled isInterface={true} singularOnly={true} priority={(new Package()).isDutch() ? 'nl' : 'en'} returnValue={
                            (language)=>{
                                this.setState({support:language.ietf})
                            }
                        } title={Translation.get(2212 , 'Support Language')}/></Col>
                    </Row>
    }

}